import { Box, styled, useTheme } from '@mui/material';
import type { ComponentProps, ReactChildren, ReactNode } from 'react';

export const ListActions = styled('div')(({ theme }) => ({
  display: 'flex',
  justifyContent: 'space-between',
  paddingBottom: theme.spacing(1),
}));

export const ListPageContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  flex: 1,
  flexDirection: 'row',
  minHeight: 0,
  [theme.breakpoints.down('sm')]: {
    flexDirection: 'column',
  },
}));

export interface ListContainerProps extends ComponentProps<typeof Box> {
  children: ReactNode | ReactChildren;
}

export const ListContainer = ({ children, sx, ...props }: ListContainerProps) => {
  const theme = useTheme();
  return (
    <Box
      sx={{
        flex: 1,
        position: 'relative',
        width: '100%',
        minHeight: 0,
        display: 'flex',
        flexDirection: 'column',
        overflow: 'hidden',
        padding: theme.spacing(2),
        pb: 0,
        [theme.breakpoints.down('sm')]: {
          pb: '54px',
        },
        ...sx,
      }}
      {...props}
    >
      {children}
    </Box>
  );
};

export const ListHeader = styled(Box)(() => ({
  position: 'sticky',
  flexShrink: 0,
  padding: 0,
}));

export const ListContent = ({ children, sx, ...props }: ComponentProps<typeof Box>) => {
  const theme = useTheme();

  return (
    <Box
      sx={{
        flexGrow: 1,
        overflowY: 'auto',
        [theme.breakpoints.down('sm')]: {
          height: 'calc(100vh - 205px)',
        },
        ...sx,
      }}
      {...props}
    >
      {children}
    </Box>
  );
};
